import { MessageCircle } from "lucide-react";

export const WhatsAppShare = ({ text, testId = "whatsapp-share-btn", label = "Share on WhatsApp" }) => (
  <a
    href={`https://wa.me/?text=${encodeURIComponent(text)}`}
    target="_blank" rel="noopener noreferrer"
    className="inline-flex items-center gap-1.5 rounded-full border border-[#3E6B4F]/40 px-4 py-1.5 font-mukta text-sm font-semibold text-[#3E6B4F] transition-colors hover:bg-[#3E6B4F] hover:text-[#FFFDF8]"
    data-testid={testId}
  >
    <MessageCircle size={15} /> {label}
  </a>
);
